import { IDisplayedSlice, IRetentionTable } from '../../interfaces';
import { assertNotNil } from '../../../../utils/types';
import { OVERALL_SLICE_KEY } from '../../constants/utils';
import { getHeaderName } from '../../../../utils/redux/transformRetentionData';
import React from 'react';
import KubitTooltip from '../../../KubitTooltip';

export const RowHeaderDisplay = ({
  table,
  rowIndex,
  displayedSlices,
}: {
  table: IRetentionTable;
  rowIndex: number;
  displayedSlices: IDisplayedSlice[];
}) => {
  const row = table.rows[rowIndex];
  assertNotNil(row);
  const { header, sliceKey } = row;
  let content: string;
  if (row.sliceKey === OVERALL_SLICE_KEY) {
    content = getHeaderName(header);
  } else {
    const displayedSlice = displayedSlices.find((s) => s.key === sliceKey);
    assertNotNil(displayedSlice);
    const sliceName = displayedSlice.name;
    content = `${getHeaderName(header)} - ${sliceName}`;
  }

  return (
    <KubitTooltip content={content} placement="bottom-start">
      <span>{content}</span>
    </KubitTooltip>
  );
};
